/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './registerPush.defs.js'
export * as $defs from './registerPush.defs.js'
